import { store } from 'store'

// заголовки для запросов
// берем из стора текущий аксес токен
export const getHeaderAuthorization = (): string | null => {
  const accessToken = store.getState().auth.authInfo.accessToken

  if (accessToken) {
    return `Bearer ${accessToken}`
  }

  return accessToken
}
